import { render, staticRenderFns } from "./DiagToDrugAndAcupoint.vue?vue&type=template&id=db54fc22&scoped=true"
import script from "./DiagToDrugAndAcupoint.vue?vue&type=script&lang=js"
export * from "./DiagToDrugAndAcupoint.vue?vue&type=script&lang=js"
import style0 from "./DiagToDrugAndAcupoint.vue?vue&type=style&index=0&id=db54fc22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db54fc22",
  null
  
)

export default component.exports